<template>
  <div>
    <div class="vs-tab" style="margin-left: 40px">
      <div :class="`vs-tab-item ${activeTab == '0' ? 'vs-tab-item-active' : ''}`" @click="changeTab('0')">电话排行榜</div>
      <div :class="`vs-tab-item ${activeTab == '1' ? 'vs-tab-item-active' : ''}`" @click="changeTab('1')">IM排行榜</div>
    </div>
    <div :class="className" :style="{height:height,width:width}" />
  </div>
</template>

<script>
// import * as echarts from 'echarts'
// require('echarts/theme/macarons') // echarts theme
import resize from './mixins/resize'

const animationDuration = 1000

export default {
  mixins: [resize],
  props: {
    className: {
      type: String,
      default: 'chart'
    },
    width: {
      type: String,
      default: '100%'
    },
    height: {
      type: String,
      default: '300px'
    }
  },
  data() {
    return {
      chart: null,
      activeTab: '0',
      data1: [79, 52, 200, 334, 390, 330, 220],
      data2: [52, 200, 334, 390, 330, 220, 79],
      chartData: [79, 52, 200, 334, 390, 330, 220],
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.initChart()
    })
  },
  beforeDestroy() {
    if (!this.chart) {
      return
    }
    this.chart.dispose()
    this.chart = null
  },
  methods: {
    changeTab(val) {
      this.activeTab = val;
      if(val == '1'){
        this.chartData = this.data2
      }else {
        this.chartData = this.data1
      }
      this.initChart()
    },
    initChart() {
      let chartDom = document.getElementsByClassName(this.className)[0]
      this.chart = echarts.init(chartDom, 'macarons')

      this.chart.setOption({
        tooltip: {
          show: false,
          // trigger: 'axis',
          // axisPointer: { // 坐标轴指示器，坐标轴触发有效
          //   type: 'shadow' // 默认为直线，可选为：'line' | 'shadow'
          // }
        },
        grid: {
          top: 10,
          left: '2%',
          right: '2%',
          bottom: '3%',
          containLabel: true
        },
        xAxis: [{
          type: 'value',
          axisTick: {
            show: false
          }
        }],
        yAxis: [{
          type: 'category',
          data: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'],
          axisTick: {
            alignWithLabel: true
          }
        }],
        series: [{
          name: 'pageA',
          type: 'bar',
          stack: 'vistors',
          // barWidth: '60%',
          data: this.chartData,
          animationDuration,
          itemStyle: {
			color: new echarts.graphic.LinearGradient(0, 0, 1, 1, [{
				offset: 0,
				color: '#C0D7FF'
			}, {
				offset: 1,
				color: '#7BABFF'
			}]),
          }
        }]
      })
    }
  }
}
</script>
